import { render, staticRenderFns } from "./MenuItemProfiles.vue?vue&type=template&id=704111a0&"
import script from "./MenuItemProfiles.vue?vue&type=script&lang=js&"
export * from "./MenuItemProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports